<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    en: {
    },
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout
  },
  data() {
    return {
      vehicle: null,

      modules: {
        coverage: null,
        tracker: null,
        inspections: null,
        payments: null,
      },

      activation: {
        modal: false,
        step: 1,

        send: {
          loading: false,
        }
      },

      loading: {
        confirm: false,
        fipe: false,
      },

      types: null,
      brands: null,
      years: null,
      models: null,
      states: [
        { "code": "AC", "name": "Acre", },
        { "code": "AL", "name": "Alagoas", },
        { "code": "AP", "name": "Amapá", },
        { "code": "AM", "name": "Amazonas", },
        { "code": "BA", "name": "Bahia", },
        { "code": "CE", "name": "Ceará", },
        { "code": "DF", "name": "Distrito Federal", },
        { "code": "ES", "name": "Espírito Santo", },
        { "code": "GO", "name": "Goiás", },
        { "code": "MA", "name": "Maranhão", },
        { "code": "MT", "name": "Mato Grosso", },
        { "code": "MS", "name": "Mato Grosso do Sul", },
        { "code": "MG", "name": "Minas Gerais", },
        { "code": "PA", "name": "Pará", },
        { "code": "PB", "name": "Paraíba", },
        { "code": "PR", "name": "Paraná", },
        { "code": "PE", "name": "Pernambuco", },
        { "code": "PI", "name": "Piauí", },
        { "code": "RJ", "name": "Rio de Janeiro", },
        { "code": "RN", "name": "Rio Grande do Norte", },
        { "code": "RS", "name": "Rio Grande do Sul", },
        { "code": "RO", "name": "Rondônia", },
        { "code": "RR", "name": "Roraima", },
        { "code": "SC", "name": "Santa Catarina", },
        { "code": "SP", "name": "São Paulo", },
        { "code": "SE", "name": "Sergipe", },
        { "code": "TO", "name": "Tocantins", },
      ],
      cities: null,

      coverage: {
        step: 1,
        modal: false,

        vehicle: {
          plate: '',
          type: '',
          brand: '',
          year: '',
          model: '',
          state: '',
          city: '',
          work: '',
        },

        confirm: null,

        fipe: null,
      },

      payment: {
        modal: false,
        id: '',
        status: '',
        date: '',
        value: '',
        methods: [],
        order: 0,
      },

      balance: {
        modal: false,
        loading: false,
        pay: '0.00',
        total: '0.00',
      },
    };
  },
  validations: {
    coverage: {
      type: { required },
      brand: { required },
      model: { required },
      year: { required },
    },
  },
  methods: {
    getVehicle() {
      this.vehicle = null;

      api
        .get("vehicles/" + this.$route.params.id)
        .then((response) => {
          if (response.data.status == "success") {
            this.vehicle = response.data.vehicle;
            this.modules.coverage = response.data.coverage;
            this.modules.tracker = response.data.tracker;
            this.modules.inspections = response.data.inspections;
            this.modules.payments = response.data.payments;
          } else {
            this.$router.push('/vehicles');
          }
        })
        .catch((error) => {
          if (error) {
            this.$router.push('/vehicles');
          }
        })
    },
    showActivation() {
      this.activation.modal = false;
      this.activation.modal = true;
      this.activation.step = 1;
      this.coverage.modal = false;

      this.coverage.vehicle.plate = '';
      this.coverage.vehicle.type = '';
      this.coverage.vehicle.brand = '';
      this.coverage.vehicle.year = '';
      this.coverage.vehicle.model = '';
      this.coverage.vehicle.state = '';
      this.coverage.vehicle.city = '';
      this.coverage.vehicle.work = '';
    },
    sendActivation(coverage) {
      this.activation.send.loading = true;

      if (coverage == 'yes') {
        api
        .post('vehicles/activation/yes', {
          id: this.vehicle.id,
          plate: this.coverage.vehicle.plate,
          type: this.coverage.vehicle.type,
          brand: this.coverage.vehicle.brand,
          year: this.coverage.vehicle.year,
          model: this.coverage.vehicle.model,
          state: this.coverage.vehicle.state,
          city: this.coverage.vehicle.city,
          work: this.coverage.vehicle.work,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.activation.send.loading = false;
            this.activation.modal = false;
            this.coverage.modal = false;
            this.$toast.success('O veículo foi ativado com sucesso, realize a vistoria para efetivar a ativação da sua cobertura.');
            this.getVehicle();
          } else {
            this.activation.send.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch(error => {
          if (error) {
            this.activation.send.loading = false;
            this.$toast.error('Ocorreu um erro ao tentar ativar o veículo, tente novamente.');
          }
        })
      } else {
        api
        .post('vehicles/activation/no', {
          id: this.vehicle.id,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.activation.modal = false;
            this.activation.send.loading = false;
            this.$toast.success('O veículo foi ativado com sucesso.');
            this.getVehicle();
          } else {
            this.activation.send.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch(error => {
          if (error) {
            this.activation.send.loading = false;
            this.$toast.error('Ocorreu um erro ao tentar ativar o veículo, tente novamente.');
          }
        })
      }
    },
    showCoverage() {
      this.activation.modal = false;
      this.coverage.modal = false;
      this.coverage.modal = true;
      this.coverage.step = 1;
    },
    searchPlate() {
      api
        .post('vehicles/plate', {
          plate: this.coverage.vehicle.plate,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.getBrands(
              response.data.plate.type,
              response.data.plate.brand,
              response.data.plate.year,
              response.data.plate.model
            );
          } else {
            this.$toast.error(response.data.message);
          }
        })
    },
    getTypes() {
      this.types = null;
      this.brands = null;
      this.years = null;
      this.models = null;

      api
        .post('vehicles/types', {})
        .then((response) => {
          this.types = response.data.list
        })
    },
    async getBrands(type = '', brand = '', year = '', model = '') {
      if (!type) {
        type = this.coverage.vehicle.type;
      }

      if (!brand) {
        brand = this.coverage.vehicle.brand;
      }

      if (!year) {
        year = this.coverage.vehicle.year;
      }

      if (!model) {
        model = this.coverage.vehicle.model;
      }

      this.brands = null;
      this.years = null;
      this.models = null;

      if (type) {
        await api
          .post('vehicles/brands', { type: type })
          .then((response) => {
            this.brands = response.data.list
          })

        await this.$nextTick();
        this.coverage.vehicle.brand = brand;

        await this.$nextTick();
        await this.getYears(type, brand, year, model);

        await this.$nextTick();
        await this.getModels(type, brand, year, model);

        this.coverage.vehicle.type = type;
      }
    },
    async getYears(type = '', brand = '', year = '', model = '') {
      if (!type) {
        type = this.coverage.vehicle.type;
      }

      if (!brand) {
        brand = this.coverage.vehicle.brand;
      }

      if (!year) {
        year = this.coverage.vehicle.year;
      }

      if (!model) {
        model = this.coverage.vehicle.model;
      }

      this.years = null;
      this.models = null;

      if (type && brand) {
        api
          .post('vehicles/years', {
            type: type,
            brand: brand,
          })
          .then((response) => {
            this.years = response.data.list
          })

        await this.$nextTick();
        this.coverage.vehicle.year = year;
      }
    },
    async getModels(type = '', brand = '', year = '', model = '') {
      if (!type) {
        type = this.coverage.vehicle.type;
      }

      if (!brand) {
        brand = this.coverage.vehicle.brand;
      }

      if (!year) {
        year = this.coverage.vehicle.year;
      }

      if (!model) {
        model = this.coverage.vehicle.model;
      }

      if (type && brand && year) {
        api
          .post('vehicles/models', {
            type: type,
            brand: brand,
            year: year,
          })
          .then((response) => {
            this.models = response.data.list
          })

          await this.$nextTick();
          this.coverage.vehicle.model = model;
      }
    },
    getCities() {
      this.cities = null;

      if (this.coverage.vehicle.state) {
        api
          .post('vehicles/cities', {
            state: this.coverage.vehicle.state
          })
          .then((response) => {
            this.cities = response.data.list
          })
      }
    },
    getConfirm() {
      if (this.coverage.vehicle.type && this.coverage.vehicle.brand && this.coverage.vehicle.year && this.coverage.vehicle.model) {
        this.loading.confirm = true

        api
          .post('vehicles/confirm', {
            type: this.coverage.vehicle.type,
            brand: this.coverage.vehicle.brand,
            year: this.coverage.vehicle.year,
            model: this.coverage.vehicle.model,
            state: this.coverage.vehicle.state,
            city: this.coverage.vehicle.city,
            work: this.coverage.vehicle.work,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.coverage.step = 3
              this.coverage.confirm = response.data.vehicle
            } else {
              this.$toast.error(response.data.message)
            }
          })
          .finally(() => {
            this.loading.confirm = false
          })
      }
    },
    getFipe() {
      if (this.coverage.vehicle.type && this.coverage.vehicle.brand && this.coverage.vehicle.year && this.coverage.vehicle.model) {
        this.loading.fipe = true

        api
          .post('vehicles/fipe', {
            type: this.coverage.vehicle.type,
            brand: this.coverage.vehicle.brand,
            year: this.coverage.vehicle.year,
            model: this.coverage.vehicle.model,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.coverage.step = 4
              this.coverage.fipe = response.data.fipe
            } else {
              this.$toast.error(response.data.message)
            }
          })
          .finally(() => {
            this.loading.fipe = false
          })
      }
    },
    showPayment(id) {
      this.payment.modal = false;
      this.payment.modal = true;
      this.payment.id = '';
      this.payment.status = '';
      this.payment.date = '';
      this.payment.value = '';
      this.payment.methods = [];
      this.payment.order = 0;
      this.balance.pay = '0.00';
      this.balance.total = '0.00';

      api
        .get('vehicles/payments/' + id)
        .then(response => {
          if (response.data.status == 'success') {
            this.payment.id = response.data.payment.id;
            this.payment.status = response.data.payment.status;
            this.payment.date = response.data.payment.date;
            this.payment.value = response.data.payment.value;
            this.payment.methods = response.data.payment.methods;
            this.payment.order = response.data.payment.order;
            this.getBalance();
          }
        })
    },
    getBalance() {
      api
        .get('wallet/balance/weekly')
        .then(response => {
          if (response.data.status == 'success') {
            this.balance.total = response.data.balance;
            this.balance.pay = parseFloat(this.balance.total) - parseFloat(this.payment.value);
          }
        })
    },
    payOrder() {
      if (this.payment.order > 0) {
        this.balance.loading = true;

        api
          .post('wallet/pay/' + this.payment.order)
          .then(response => {
            if (response.data.status == 'success') {
              this.$toast.success('O pedido foi pago com sucesso.')
              this.payment.modal = false;
              this.getVehicle();
            }
          })
          .catch(error => {
            if (error) {
              this.balance.loading = false;
            }
          })
          .finally(() => {
            this.balance.loading = false;
          })
      }
    },
  },
  mounted() {
    this.getVehicle();
    this.getTypes();
  },
  watch: {
    "coverage.vehicle.type": function () {
      this.getBrands();
    },
    "coverage.vehicle.brand": function () {
      this.getYears();
    },
    "coverage.vehicle.year": function () {
      this.getModels();
    },
    "coverage.vehicle.state": function () {
      this.getCities();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/vehicles">Meus Veículos</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Veículo</li>
    </ol>

    <div v-if="vehicle" class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Veículo no. {{ vehicle.id }}</h3>
        <p></p>
      </div>
    </div>

    <fieldset>
      <legend>Meu Veículo</legend>

      <div class="text-center d-flex justify-content-center align-items-center" v-if="!vehicle">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>

      <div v-else-if="vehicle">
        <template v-if="vehicle.coverage && vehicle.coverage == 'active'">
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.monthly | currency }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">MENSALIDADE</div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">DIA {{ vehicle.date_due }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VENCIMENTO</div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.plate }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">PLACA</div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.city }}/{{ vehicle.state }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">LOCALIDADE</div>
            </div>
            <div class="col-6 col-md-3 mb-3">
              <h6 class="mb-0">{{ vehicle.price | currency }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VALOR FIPE</div>
            </div>
            <div class="col-12 col-md-12">
              <h6 class="mb-0">{{ vehicle.brand }} {{ vehicle.model }} {{ vehicle.year }}</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VEÍCULO</div>
            </div>
          </div>
        </template>
        <template v-else-if="vehicle.coverage && vehicle.coverage == 'inactive'">
          <div class="row">
            <div class="col-6 col-md-3">
              <h5 class="mb-0">{{ vehicle.monthly | currency }}</h5>
              <div class="badge badge-soft-default font-size-13 text-uppercase">MENSALIDADE</div>
            </div>
            <div class="col-6 col-md-3">
              <h5 class="mb-0">DIA {{ vehicle.date_due }}</h5>
              <div class="badge badge-soft-default font-size-13 text-uppercase">VENCIMENTO</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
              <path
                d="M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z">
              </path>
            </svg>
            <h4 class="mt-3">Você ainda não ativou o seu veículo!</h4>
            <p>Para ativar o seu veículo, clique no botão abaixo.</p>
            <button class="btn btn-primary btn-lg" v-on:click="showActivation()">Ativar Veículo</button>
          </div>
        </template>
      </div>
    </fieldset>

    <b-modal v-model="activation.modal" modal-class="modal-right" title="Ativação de Veículo" hide-footer>
      <template v-if="activation.step == 1">
        <h5>Para ativar o seu veículo, escolha uma das opções abaixo:</h5>
        <div class="row mt-4">
          <div class="col-6">
            <button class="btn btn-warning btn-lg btn-block text-uppercase" v-on:click="activation.step = 2">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: #fff;">
                <path
                  d="M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z">
                </path>
              </svg><br>
              <div class="pt-2">Ativar sem cobertura</div>
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-success btn-lg btn-block text-uppercase" v-on:click="activation.step = 3">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: #fff;">
                <path
                  d="M3 19.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845l-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684z">
                </path>
                <path d="M22 7.388V5.279l-9.684-3.228a.996.996 0 0 0-.658.009L2 5.572V7.7l10.015-3.642L22 7.388z"></path>
              </svg><br>
              <div class="pt-2">Ativar com cobertura</div>
            </button>
          </div>
        </div>
      </template>
      <template v-else-if="activation.step == 2">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: #312F4F;">
            <path
              d="M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z">
            </path>
          </svg><br>
          <h5 class="my-3">Você escolheu ativar o seu veículo sem cobertura LI Garantido</h5>
          <p>ATENÇÃO: Ao ativar o seu veículo sem cobertura, você não terá cobertura para roubo e furto. Você receberá apenas o rastreador para localização do seu veículo e benefícios.</p>
          <ul>
            <li>Rastreamento Inteligente</li>
            <li>Telemedicina</li>
            <li>Club de Descontos</li>
          </ul>
          <div class="mt-5 d-flex justify-content-between">
            <button class="btn btn-light btn-lg" v-on:click="activation.step = 1">Voltar</button>
            <button class="btn btn-default btn-lg" v-on:click="sendActivation('no')">
              Confirmar
              <b-spinner v-if="activation.send.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
          </div>
        </div>
      </template>
      <template v-else-if="activation.step == 3">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: #312F4F;">
            <path
              d="M3 19.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845l-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684z">
            </path>
            <path d="M22 7.388V5.279l-9.684-3.228a.996.996 0 0 0-.658.009L2 5.572V7.7l10.015-3.642L22 7.388z"></path>
          </svg><br>
          <h5 class="my-3">Você escolheu ativar o seu veículo com cobertura LI Garantido</h5>
          <p>ATENÇÃO: Ao ativar o seu veículo com cobertura LI Garantido, você terá cobertura para roubo e furto. Você receberá o rastreador para localização do seu veículo e a cobertura para os
            eventos mencionados.</p>
          <ul>
            <li>Roubo e Furto</li>
            <li>01 Reboque por ano</li>
            <li>Assistência 24h</li>
            <li>Telemedicina 24h</li>
            <li>Club de Desconto</li>
          </ul>
          <p class="bg-soft-info rounded p-3 font-size-12 text-uppercase">Após a confirmação você irá informar os dados do seu veículo e realizar a vistoria para efetivar a ativação da sua cobertura.
          </p>
          <div class="mt-5 d-flex justify-content-between">
            <button class="btn btn-light btn-lg" v-on:click="activation.step = 1">Voltar</button>
            <button class="btn btn-default btn-lg" v-on:click="showCoverage()">
              Avançar
              <b-spinner v-if="activation.send.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="coverage.modal" modal-class="modal-right" title="Ativação do Veículo" hide-footer>
      <b-progress :value="coverage.step" max="4" variant="default" height="15px"></b-progress>

      <template v-if="coverage.step == 1">
        <div class="my-5">
          <b-form-group label="Placa" label-for="coverage.vehicle.plate">
            <b-form-input v-model="coverage.vehicle.plate" v-mask="'XXXXXXX'" required class="text-uppercase text-center font-size-24" v-on:blur="searchPlate()"></b-form-input>
          </b-form-group>
          <b-form-group class="vehicle-radios" label="Tipo veículo" label-for="coverage.vehicle.type">
            <b-form-radio v-model="coverage.vehicle.type" value="cars">Carro</b-form-radio>
            <b-form-radio v-model="coverage.vehicle.type" value="motorcycles">Moto</b-form-radio>
            <b-form-radio v-model="coverage.vehicle.type" value="trucks">Caminhão</b-form-radio>
          </b-form-group>
          <div class="row">
            <div class="col-6">
              <b-form-group label="Marca" label-for="coverage.vehicle.brand">
                <b-form-select v-model="coverage.vehicle.brand" required>
                  <option v-if="coverage.vehicle.type && !brands" value="">Carregando...</option>
                  <option v-else-if="brands" value="">– Selecione</option>
                  <option v-else value="">–</option>
                  <option v-for="(option, index) in brands" :key="index" :value="option.code">
                    {{ option.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group label="Ano" label-for="coverage.vehicle.year">
                <b-form-select v-model="coverage.vehicle.year" required>
                  <option v-if="coverage.vehicle.brand && !years" value="">Carregando...</option>
                  <option v-else-if="years" value="">– Selecione</option>
                  <option v-else value="">–</option>
                  <option v-for="(option, index) in years" :key="index" :value="option.code">
                    {{ option.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
          <b-form-group label="Modelo" label-for="coverage.vehicle.model">
            <b-form-select v-model="coverage.vehicle.model" required>
              <option v-if="coverage.vehicle.year && !models" value="">Carregando...</option>
              <option v-else-if="models" value="">– Selecione</option>
              <option v-else value="">–</option>
              <option v-for="(option, index) in models" :key="index" :value="option.code">
                {{ option.name }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg btn-block" :disabled="coverage.vehicle.type == '' || coverage.vehicle.brand == '' || coverage.vehicle.year == '' || coverage.vehicle.model == ''"
            v-on:click="coverage.step = 2">Próximo passo</button>
        </div>
      </template>
      <template v-else-if="coverage.step == 2">
        <div class="my-5">
          <b-form-group label="Moro no estado" label-for="coverage.vehicle.state">
            <b-form-select v-model="coverage.vehicle.state" required>
              <option value="">–</option>
              <option v-for="(option, index) in states" :key="index" :value="option.code">
                {{ option.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Na cidade" label-for="coverage.vehicle.city">
            <b-form-select v-model="coverage.vehicle.city" required>
              <option v-if="coverage.vehicle.state && !cities" value="">Carregando...</option>
              <option v-else-if="cities" value="">– Selecione</option>
              <option v-else value="">–</option>
              <option v-for="(option, index) in cities" :key="index" :value="option.code">
                {{ option.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group class="vehicle-radios" label="Você usa o seu veículo em Táxi ou Aplicativo?" label-for="coverage.vehicle.work">
            <b-form-radio v-model="coverage.vehicle.work" value="yes">Sim</b-form-radio>
            <b-form-radio v-model="coverage.vehicle.work" value="no">Não</b-form-radio>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-light btn-lg" v-on:click="coverage.step = 1">Voltar</button>
          <button class="btn btn-default btn-lg" :disabled="coverage.vehicle.state == '' || coverage.vehicle.city == '' || coverage.vehicle.work == '' || loading.confirm" v-on:click="getConfirm();">
            Próximo passo
            <b-spinner v-if="loading.confirm" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </template>
      <template v-else-if="coverage.step == 3">
        <div class="my-5">
          <h5 class="mb-4">Confira o seu veículo</h5>
          <div class="card">
            <div class="card-body" v-if="coverage.confirm">
              <div class="d-flex justify-content-between">
                <div>Marca</div>
                <div>{{ coverage.confirm.brand }}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div>Ano</div>
                <div>{{ coverage.confirm.year }}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div>Modelo</div>
                <div>{{ coverage.confirm.model }}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div>Cidade</div>
                <div>{{ coverage.confirm.city }}/{{ coverage.confirm.state }}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div>Táxi ou Aplicativo?</div>
                <div v-if="coverage.vehicle.work == 'yes'">Sim</div>
                <div v-else>Não</div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-light btn-lg" v-on:click="coverage.step = 2">Voltar</button>
          <button class="btn btn-default btn-lg" :disabled="loading.fipe" v-on:click="getFipe()">
            Próximo passo
            <b-spinner v-if="loading.fipe" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </template>
      <template v-else-if="coverage.step == 4">
        <div class="my-5">
          <h5 class="mb-4">Confira o valor da sua mensalidade</h5>
          <div class="card mb-1">
            <div class="card-body">
              <div class="mt-1"><span class="bg-soft-warning rounded py-1 px-2 font-size-12 text-uppercase">Veículo</span></div>
              <div class="mt-2 px-1">
                {{ coverage.confirm.brand }}<br>
                {{ coverage.confirm.model }}<br>
                {{ coverage.confirm.year }}
              </div>
            </div>
          </div>
          <div v-if="coverage.fipe && coverage.fipe.price" class="card mb-1">
            <div class="card-body">
              <div class="mt-1"><span class="bg-soft-warning rounded py-1 px-2 font-size-12 text-uppercase">Valor da Fipe</span></div>
              <div class="mt-2 px-1">{{ coverage.fipe.price | currency }}</div>
            </div>
          </div>
          <div v-if="coverage.fipe && coverage.fipe.plan" class="card">
            <div class="card-body">
              <div class="mt-1"><span class="bg-soft-warning rounded py-1 px-2 font-size-12 text-uppercase">Valor da Mensalidade</span></div>
              <div class="mt-2 px-1">{{ coverage.fipe.plan | currency }}</div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-light btn-lg" v-on:click="coverage.step = 3">Voltar</button>
          <button class="btn btn-default btn-lg"
            :disabled="coverage.vehicle.plate == '' || coverage.vehicle.type == '' || coverage.vehicle.brand == '' || coverage.vehicle.year == '' || coverage.vehicle.model == '' || coverage.vehicle.state == '' || coverage.vehicle.city == '' || coverage.vehicle.work == '' || loading.checkout"
            v-on:click="sendActivation('yes')">
            Confirmar
            <b-spinner v-if="activation.send.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </template>
    </b-modal>

    <div class="row">
      <div class="col-12 col-md-6">
        <fieldset class="pb-0">
          <legend>Minha Cobertura</legend>
          <div class="row" v-if="modules.coverage">
            <div class="col-12 col-md-6 mb-3">
              <h6 class="mb-0" v-if="modules.coverage.status == 'await_activation'">Aguardando ativação</h6>
              <h6 class="mb-0" v-else-if="modules.coverage.status == 'active'">Ativo</h6>
              <h6 class="mb-0" v-else-if="modules.coverage.status == 'inactive'">Inativo</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">Status</div>
            </div>
            <div class="col-12 col-md-12 mb-3" v-if="modules.coverage && modules.coverage.contract">
              <h6 class="mb-0" v-if="modules.coverage.contract.status == 'await'">–</h6>
              <h6 class="mb-0" v-else-if="modules.coverage.contract.status == 'sent'">Aguardando assinatura</h6>
              <h6 class="mb-0" v-else-if="modules.coverage.contract.status == 'signed'">Assinado</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">Contrato</div>
            </div>
          </div>
          <div class="mb-3" v-if="modules.coverage && modules.coverage.contract && modules.coverage.contract.status == 'await'">
            <a href="#" class="btn btn-outline-default btn-block btn-lg disabled">
              Assinar contrato
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: currentColor">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
          <div class="mb-3" v-if="modules.coverage && modules.coverage.contract && modules.coverage.contract.status == 'sent'">
            <a :href="modules.coverage.contract.url" target="_blank" class="btn btn-default btn-block btn-lg">
              Assinar contrato
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: #ffff">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
          <div class="mb-3" v-if="modules.coverage && modules.coverage.contract && modules.coverage.contract.status == 'signed'">
            <a :href="modules.coverage.contract.url" target="_blank" class="btn btn-outline-default btn-block btn-lg">
              Ver contrato
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: currentColor">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
        </fieldset>
      </div>
      <div class="col-12 col-md-6">
        <fieldset class="pb-0">
          <legend>Meu Rastreador</legend>
          <div class="row" v-if="modules.tracker">
            <div class="col-6 col-md-6 mb-3">
              <h6 class="mb-0" v-if="modules.tracker.status == 'await_activation'">Aguardando ativação</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'await_payment'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'payment_pending'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'activation_progress'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'active'">Ativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'overdue'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'suspended'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'canceled_client'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'canceled_overdue'">Inativo</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.status == 'inactive'">Inativo</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">Status</div>
            </div>
            <div class="col-6 col-md-6 mb-3">
              <h6 class="mb-0" v-if="modules.tracker.imei">{{ modules.tracker.imei }}</h6>
              <h6 class="mb-0" v-else>–</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">IMEI</div>
            </div>
            <div class="col-12 col-md-12 mb-3" v-if="modules.tracker && modules.tracker.contract">
              <h6 class="mb-0" v-if="modules.tracker.contract.status == 'pending'">–</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.contract.status == 'sent'">Aguardando assinatura</h6>
              <h6 class="mb-0" v-else-if="modules.tracker.contract.status == 'signed'">Assinado</h6>
              <div class="badge badge-soft-default font-size-13 text-uppercase">Contrato</div>
            </div>
          </div>
          <div class="mb-3" v-if="modules.tracker && modules.tracker.contract && modules.tracker.contract.status == 'signed'">
            <a :href="modules.tracker.contract.url" target="_blank" class="btn btn-outline-default btn-block btn-lg">
              Ver contrato
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: currentColor">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
          <div class="mb-3" v-else>
            <a class="btn btn-outline-default btn-block btn-lg disabled">
              Ver contrato
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: currentColor">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
        </fieldset>
      </div>
    </div>

    <fieldset v-if="modules.inspections">
      <legend>Vistorias</legend>
      <div class="text-center d-flex justify-content-center align-items-center" v-if="!modules.inspections">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="modules.inspections && modules.inspections.length == 0" class="text-center d-flex justify-content-center align-items-center">
        <div>
          nenhum vistoria encontrada
        </div>
      </div>
      <div v-else class="table-responsive">
        <table class="table table-centered table-nowrap table-hover">
          <thead class="thead-light">
            <tr>
              <th>Data</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in modules.inspections" :key="row.index">
              <td class="text-uppercase">{{ row.date }}</td>
              <td>
                <span v-if="row.status == 'notsent'" class="badge badge-soft-danger font-size-13 text-uppercase">Não Enviado</span>
                <span v-else-if="row.status == 'pending'" class="badge badge-soft-warning font-size-13 text-uppercase">Em Análise</span>
                <span v-else-if="row.status == 'reanalysis'" class="badge badge-soft-info font-size-13 text-uppercase">Reanálise</span>
                <span v-else-if="row.status == 'approved'" class="badge badge-soft-success font-size-13 text-uppercase">Aprovado</span>
                <span v-else-if="row.status == 'repproved'" class="badge badge-soft-danger font-size-13 text-uppercase">Reprovado</span>
              </td>
              <td class="text-right">
                <router-link :to="'/vehicles/inspections/' + row.id" class="btn btn-default btn-sm btn-rounded font-size-14">
                  Ver
                  <i class="mdi mdi-arrow-right ml-1"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

    <fieldset v-if="modules.payments">
      <legend>Mensalidades</legend>

      <div class="text-center d-flex justify-content-center align-items-center" v-if="!modules.payments">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>

      <div v-else-if="modules.payments && modules.payments.length == 0" class="text-center d-flex justify-content-center align-items-center">
        <div>
          nenhum mensalidade encontrada
        </div>
      </div>

      <div v-else class="table-responsive">
        <table class="table table-centered table-nowrap table-hover">
          <thead class="thead-light">
            <tr>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in modules.payments" :key="row.index">
              <td class="text-uppercase">{{ row.date }}</td>
              <td>{{ row.value | currency }}</td>
              <td>
                <span v-if="row.status == 'pending'" class="badge badge-soft-danger font-size-13 text-uppercase">Pendente</span>
                <span v-else-if="row.status == 'approved'" class="badge badge-soft-success font-size-13 text-uppercase">Pago</span>
              </td>
              <td class="text-right">
                <button class="btn btn-default btn-sm btn-rounded font-size-14" v-on:click="showPayment(row.id)">
                  Ver
                  <i class="mdi mdi-arrow-right ml-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

    <b-modal v-model="payment.modal" modal-class="modal-right" :title="payment.date" hide-footer>
      <div v-if="!payment.id" class="text-center d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else>
        <div class="mb-5">
          <div class="mb-3">
            <span v-if="payment.status == 'pending'" class="badge badge-soft-danger p-1 px-2 font-size-13 text-uppercase">Pendente</span>
            <span v-else-if="payment.status == 'approved'" class="badge badge-soft-success p-1 px-2 font-size-13 text-uppercase">Pago</span>
          </div>
          <h3 class="mb-0">{{ payment.value | currency }}</h3>
          <div class="text-uppercase">
            Vencimento {{ payment.date }}
          </div>
        </div>

        <b-tabs v-if="payment.status === 'pending'" justified nav-class="nav-tabs-custom mt-3" content-class="py-3 text-muted">
          <b-tab v-for="(pay, method) in payment.methods" :key="method">
            <template v-slot:title>{{ pay.name }}</template>
            <div v-if="method == 'pix'" class="py-3 text-center">
              <div v-if="pay.pix && pay.pix.text">
                <div v-if="pay.pix.image">
                  <div>
                    Use o código QR para prosseguir com a transação.
                  </div>
                  <div class="my-4 d-flex justify-content-center">
                    <div class="border rounded p-3">
                      <img style="width: 180px" :src="'data:image/png;base64,' + pay.pix.image" />
                    </div>
                  </div>
                  <div>
                    Ou utilize o Pix Copia e Cola para prosseguir com a transação.
                  </div>
                </div>
                <div v-else>
                  Use o Pix Copia e Cola para prosseguir com a transação.
                </div>
                <div class="my-4">
                  <fieldset class="text-break py-3">{{ pay.pix.text }}</fieldset>
                </div>
                <div>
                  <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pay.pix.text"
                    v-on:click="$toast.success('<strong>Copiado para a área de transferência.</strong><br>Agora, tudo o que você precisa fazer é acessar o aplicativo do seu banco e concluir o processo usando o <strong>Pix Copia e Cola</strong>.')">
                    Copiar Pix Copia e Cola
                  </button>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </Layout>
</template>
<style>
.vehicle-radios>div {
  display: flex;
  gap: 10px
}

.vehicle-radios>div .custom-control {
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #D1D1E3;
  border-radius: 6px;
  flex: 1 1 auto !important;
  padding-left: 0;
}

.vehicle-radios>div .custom-radio .custom-control-label {
  padding: 13px 13px 13px 43px;
  font-size: 14px;
}

.vehicle-radios>div .custom-radio .custom-control-label::before {
  top: 12px;
  left: 9px;
  width: 1.5rem;
  height: 1.5rem;
}

.vehicle-radios>div .custom-radio .custom-control-label::after {
  top: 12px;
  left: 9px;
  width: 1.5rem;
  height: 1.5rem;
}
</style>
